/* eslint-disable jsx-a11y/role-supports-aria-props */

import React from 'react';

import style from './FAQPage.module.css';
import Back from '../common/Back';

const FAQPage = React.memo(() => {
  return (
    <div className={style.faq}>
      <Back path="/tools" text="Reference Tools" />
      <h1>Frequently Asked Questions</h1>
      <section className={style.content}>
        <h2
          data-toggle="collapse"
          className="collapsed"
          href="#privately-head"
          aria-expanded="false"
        >
          What is the Privately Held and Not for Profit Management Liability
          Consolidation project?
        </h2>
        <div id="privately-head" className="collapse">
          This initiative will streamline our quote-bind-issuance process for
          privately held and not for profit management liability policies (for D
          & O, EPLI, Fiduciary and Crime with premium under $25,000). It
          includes:
          <ul>
            <li>
              A “panel” of eight well-established insurance companies, who have
              agreed to provide the following:
            </li>
            <ul>
              <li>
                <span className={style.dash}>-</span> Standardized
                quote-bind-issuance process;
              </li>
              <li>
                <span className={style.dash}>-</span> Common electronic
                applications and fulfillment process;
              </li>
              <li>
                <span className={style.dash}>-</span> Broad consistent coverage
                for all risks;
              </li>
              <li>
                <span className={style.dash}>-</span> Common proposal templates
                that pre-filled and ready to be sent to the clients; and
              </li>
              <li>
                <span className={style.dash}>-</span> Access to subject matter
                experts to consult with our field offices and HUB colleagues
              </li>
            </ul>
          </ul>
        </div>
        <h2 data-toggle="collapse" className="collapsed" href="#only-impacts">
          What is in-scope?
        </h2>
        <div id="only-impacts" className="collapse">
          <p>
            This change only impacts privately held and not for profit liability
            management clients (with premiums under $25,000) for the following
            coverage lines:
          </p>
          <ul>
            <li>Directors and Officers Liability;</li>
            <li>Employment Practices Liability;</li>
            <li>Fiduciary Liability; and</li>
            <li>Crime/Employee Dishonesty/Corporate Fidelity</li>
          </ul>
        </div>

        <h2 data-toggle="collapse" className="collapsed" href="#private-held">
          Why are we consolidating private held and not for profit management
          liability?
        </h2>

        <div id="private-held" className="collapse">
          Benefits include:
          <ul>
            <li>
              Coverage enhancements (on over 67 coverage items) are now market
              standard or market leading. Our consolidation’s terms, as
              pre-negotiated, are market leading.
            </li>
            <li>
              The eight selected insurance companies on our panel will provide
              quotes within 1 to 48 hours after receiving the submitted
              application. Our goal is to reduce this timeline to minutes.
            </li>
            <li>
              E & O exposures via placement will be either reduced or
              eliminated.
            </li>
            <li>
              There will be a reduced dependence (or even an elimination) of
              wholesalers and other intermediaries.
            </li>
            <li>Improved workflow experienced throughout HUB.</li>
            <li>
              At the field level, more time to win new business and explore
              deeper relationships throughout your client and prospect universe,
              as well as more time to lead and advocate for your clients and
              prospects in other P & C and Management Lines of Business.
            </li>
            <li>
              Your continued trusted advocacy to our clients and prospects will
              be prevalent.
            </li>
          </ul>
        </div>

        <h2 data-toggle="collapse" className="collapsed" href="#expected">
          Who will benefit from this change?
        </h2>
        <div id="expected" className="collapse">
          <p>Those expected to benefit directly are:</p>
          <ul>
            <li>Sales (e.g. Producers);</li>
            <li>Account Servicers (e.g. CSRs, Account Mgrs., etc.);</li>
            <li>Insurance companies for these types of policies; and</li>
            <li>
              Customers, who are seeking privately held and not for profit
              management liability policies.
            </li>
          </ul>
        </div>

        <h2
          data-toggle="collapse"
          className="collapsed"
          href="#selected-insurance"
        >
          Who are the selected insurance companies on our panel?
        </h2>
        <div id="selected-insurance" className="collapse">
          <p>
            Currently, in no particular order, our panel of insurance companies
            consists of:
          </p>
          <ul>
            <li>Arch;</li>
            <li>C.N.A.;</li>
            <li>Chubb;</li>
            <li>Hiscox;</li>
            <li>Navigators;</li>
            <li>Travelers;</li>
            <li>Hanover; and</li>
            <li>Everest.</li>
          </ul>
          <p>
            Note: Other insurance companies may be periodically added to our
            panel.
          </p>
        </div>

        <h2
          data-toggle="collapse"
          className="collapsed"
          href="#insurance-companies"
        >
          How were the insurance companies selected for the panel?
        </h2>
        <div id="insurance-companies" className="collapse">
          <p>
            Fourteen industry leading insurance companies with deep expertise in
            small Management Liability were selected to participate and respond
            to the HUB Request for Proposal (RFP). Eight were chosen by your HUB
            ML task force based on a number of factors, such as their:
          </p>
          <ul>
            <li>
              Gross Written Premium (GWP) and inforce policy account with HUB or
              throughout the industry
            </li>
            <li>AM Best Rating</li>
            <li>
              Underwriting expertise, depth of talent and appetite for risks in
              ML
            </li>
            <li>
              Claims expertise, depth of talent and reputations in ML and P & C
              in general
            </li>
            <li>
              Willingness to achieve or exceed the coverage enhancements
              requested by HUB ML SME’s and willingness to accept /underwrite
              from the HUB Universal Proprietary applications.
            </li>
            <li>
              Commitment to service standards in the placement process – from
              quote to binding to issuance of policy documents, including
              electronic fulfillment
            </li>
          </ul>
        </div>

        <h2 data-toggle="collapse" className="collapsed" href="#rollout">
          What is the rollout timeline?
        </h2>
        <div id="rollout" className="collapse">
          <p>For the HUB Universal ML application:</p>
          <ul>
            <li>
              We are currently rolling it out to Midwest West. Then, it will be
              rolled out to the other HUBs. Sequential order has yet to be
              confirmed.
            </li>
          </ul>
          <p>For the standardized electronic fulfillment system:</p>
          <ul>
            <li>
              The Pilot is scheduled towards the end of September. The Midwest
              West HUB has agreed to be part of this initial wave. Additional
              information will be forthcoming over the next couple of weeks.
            </li>
            <li>
              Wave 1 will likely occur later this year, which tentatively
              includes Mountain State, Colorado and New Mexico. Confirmation of
              Wave 1 HUB participants, as well as additional information, will
              be provided closer to launch.
            </li>
            <li>
              Additional Waves will occur in 2019. Information about these
              future waves will be communicated closer to each launch.
            </li>
          </ul>
        </div>

        <h2 data-toggle="collapse" className="collapsed" href="#rolling-out">
          What do you mean that we are rolling out an “electronic fulfillment”
          system?
        </h2>
        <div id="rolling-out" className="collapse">
          <p>
            Generally speaking, we are automating the quote-bind-issuance
            process for privately held and not for profit management liability
            policies. Instead of manually requesting insurance companies to
            provide new business and renewal quotes for our customers, Account
            Servicers (e.g. Account Managers, CSRs) will complete the new HUB
            Universal Application through an on-line user experience. By
            completing the application within the fulfillment system, a quote
            request will be sent to the eight panel carriers at once. The panel
            will return their quotes to the fulfillment system where Account
            Servicers can review quotes and see side-by-side comparisons of
            coverage terms. Instead of days to weeks, we estimate initially it
            will take 1 to 48 hours to receive quotes – with a longer HUB
            objective to reduce this process to minutes. Ultimately, the new
            electronic fulfillment solution will yield incredible support to you
            from the buyer, achieve their peace of mind and help position HUB as
            the most trusted advocate in the management liability intermediary
            world.
          </p>
        </div>

        <h2 data-toggle="collapse" className="collapsed" href="#project-team">
          Who is on the project team?
        </h2>
        <div id="project-team" className="collapse">
          <div className="project-team">
            <p>
              The project team consists of a mix of HUB and Insureon staff,
              including:
            </p>
            <p>
              <b>Steering Committee:</b> Chris Treanor; Maryellen Dolan; Scott
              Rouzer; Bob Stalker; Adrian Atilano; Chris Taylor; Rich Mozack;
              Carla Moradi; Nicole Bossert; Bhuvana Badrinathan; Ralph Auriemma;
              Seth McCallister; Seth Morrell; Chris Kim; Paul Grote; and
              Michelle Davies
            </p>
            <p>
              <b>Project Mgmt.:</b> Chris Kim; and Paul Grote
            </p>
            <p>
              <b>Business Processes:</b> Maryellen Dolan; and (from Insureon)
              Brian Alban
            </p>
            <p>
              <b>IT Solutions:</b> Eric Enghauser; and (from Insureon) Joseph
              Nichols
            </p>
            <p>
              <b>Testing:</b> Shannan Ledden; Kash Rahim; and (from Insureon)
              Joseph Nichols
            </p>

            <p>
              <b>IT Deployment:</b> Eric Enghauser; and (from Insureon) Joseph
              Nichols
            </p>
            <p>
              <b>Business Deployment:</b> Keith Doan; Shelby Crooks; and (from
              Insureon) Angela Carlson
            </p>
            <p>
              <b>Org. Change Mgmt.:</b> Michelle Davies; and (from Insureon)
              Angela Carlson
            </p>
            <p>
              <b>Change Ambassadors:</b> TBD for each HUB
            </p>
          </div>
        </div>

        <h2 data-toggle="collapse" className="collapsed" href="#HUB-Universal">
          When should I use the HUB Universal ML application?
        </h2>
        <div id="HUB-Universal" className="collapse">
          <p>
            Please use EITHER the HUB Universal ML application for privately
            held clients and prospects) OR the HUB Universal ML application for
            not for profit clients and prospects when completing management
            liability terms/policies (with premiums under $25,000) for the
            following coverage lines:
          </p>
          <ul>
            <li>Directors and Officers Liability;</li>
            <li>Employment Practices Liability;</li>
            <li>Fiduciary Liability; and</li>
            <li>Crime/Employee Dishonesty/Corporate Fidelity</li>
          </ul>
          <p>
            It is extremely important that you properly classify the Insured
            (for-profit v. non profit) and fully complete the HUB Universal
            Application.
          </p>
        </div>

        <h2
          data-toggle="collapse"
          className="collapsed"
          href="#publicly-traded"
        >
          My client is a publicly traded risk on NASDAQ, NYSE, or another
          exchange. Should I complete the HUB Universal ML Application?
        </h2>
        <div id="publicly-traded" className="collapse">
          <p>
            No. Publicly traded risks should NOT be submitted on the HUB
            Universal ML Application nor via the new electronic fulfillment
            system. Instead, please continue to produce, submit, bind & win
            through your usual HUB placement strategies, processes and
            documentation.
          </p>
        </div>

        <h2
          data-toggle="collapse"
          className="collapsed"
          href="#privately-cyber"
        >
          My client has a packaged policy about to expire that has cyber
          liability or K R & E or another traditional ML line of coverage
          included (such as Workplace Violence or Active Shooter). Should I
          complete the HUB Universal ML application for privately held or not
          for profit risks?
        </h2>
        <div id="privately-cyber" className="collapse">
          <p>
            Not at this time. Cyber, K R & E and other executive risk coverages
            are not posed on these applications. In addition, coverage
            enhancements (as they relate to cyber and K R & E and other lines of
            executive risk coverages) have not been included for this platform
            or for these risks.
          </p>
        </div>

        <h2
          data-toggle="collapse"
          className="collapsed"
          href="#policies-placed"
        >
          My client has their management liability policies placed with their
          current P&C Package and Workers Compensation carrier. Should their
          policies be submitted to the Panel?
        </h2>
        <div id="policies-placed" className="collapse">
          <p>
            Yes. All privately held and not for profit clients (that currently
            purchase management liability policies of less than $25,000 in
            premium) should be submitted. The client’s incumbent policies should
            be compared to the best-in-class coverages proposed by the
            panelists. Client teams should propose and recommend the best
            coverage to the client at renewal.
          </p>
        </div>

        <h2 data-toggle="collapse" className="collapsed" href="#industries">
          Which industries are NOT likely to see a competitive or bindable quote
          solution from the new panel or electronic fulfillment system?
        </h2>
        <div id="industries" className="collapse">
          <p>Industries are:</p>
          <ul>
            <li>Cannabis related clients</li>
            <li>Community associations</li>
            <li>Veterinarian related risks</li>
          </ul>
        </div>

        <h2 data-toggle="collapse" className="collapsed" href="#client">
          I have a client, who is private or not for profit, but is expiring at
          $25,001 +. Should I complete the HUB Universal ML application?
        </h2>
        <div id="client" className="collapse">
          <p>
            Yes. Please complete this application and plan to submit the risk to
            our eight panel insurance companies. However, please note that if
            the quote received is &lgt; $ 25,000, then the coverage enhancements
            pre-negotiated for HUB for our risks will need to be affirmed and
            individually negotiated. We recommend that you consult your HUB
            Management Liability Subject Matter Expert for the best terms and
            market leading coverages for your client.
          </p>
        </div>

        <h2 data-toggle="collapse" className="collapsed" href="#questions">
          Where do I go if I have questions, comments and/or concerns?
        </h2>
        <div id="questions" className="collapse">
          <p>
            Please contact Keith Doan via email
            (Keith.doan@hubinternational.com). Or, you can call him directly at
            214-979-6221 and 214-923-2724.
          </p>
        </div>
      </section>
    </div>
  );
});

FAQPage.propTypes = {};

export default FAQPage;
